import { graphql } from "msw";
import { mockCart, mockCartOrderSummary } from "./mockCart";
import {
  RedeemGiftCardMutationVariables,
  RedeemGiftCardMutation,
} from "@cart-app/generated/graphql";
import {
  GIFT_CARD_THAT_WILL_THROW_ERROR,
  ONEPASS_REWARD_TEST_CODE,
} from "@cart-app/mocks/constants";
import { GIFT_CARD_APPLY_VALIDATION_MESSAGE } from "@cart-app/consts";

export const handler = graphql.mutation<
  RedeemGiftCardMutation,
  RedeemGiftCardMutationVariables
>("RedeemGiftCard", (req, res, ctx) => {
  const {
    giftCard: { code },
  } = req.variables;

  if (code === GIFT_CARD_THAT_WILL_THROW_ERROR) {
    return res(
      ctx.data({
        redeemGiftCard: {
          __typename: "UserError" as const,
          message: GIFT_CARD_APPLY_VALIDATION_MESSAGE,
        },
      })
    );
  }

  const modifiedGiftCards = [
    ...(mockCartOrderSummary.giftCards || []),
    {
      code,
      isOnePassReward: code === ONEPASS_REWARD_TEST_CODE ? true : false,
      appliedBalance: {
        amount: 10000,
        currency: "AUD",
      },
      remainingBalance: {
        amount: 50000,
        currency: "AUD",
      },
    },
  ];

  const modifiedCardTotalPriceAmount = Math.max(
    modifiedGiftCards.reduce(
      (acc, giftCard) => (acc -= giftCard.appliedBalance.amount),
      mockCartOrderSummary.subtotalPrice.amount
    ),
    0
  );

  return res(
    ctx.data({
      redeemGiftCard: {
        __typename: "Cart" as const,
        ...mockCart,
        orderSummary: {
          ...mockCartOrderSummary,
          id: mockCartOrderSummary.id,
          giftCards: modifiedGiftCards,
          totalPrice: {
            __typename: "Money" as const,
            amount: modifiedCardTotalPriceAmount,
          },
        },
      },
    })
  );
});
